import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../i18n';
import './LanguageSwitcher.css';
import { markLanguageChosen } from '../../utils/region';

const LanguageSwitcher = ({ variant = 'desktop' }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const handleSelect = (code) => {
    markLanguageChosen();
    i18n.changeLanguage(code);
    setOpen(false);
  };

  const iconSize = variant === 'mobile' ? 20 : 22;

  return (
    <div className={`lang-switcher lang-switcher--${variant}`} ref={ref}>
      <button
        className="lang-switcher-btn"
        onClick={() => setOpen(!open)}
        aria-label="Change language"
        title="Change language"
      >
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 8l6 0" />
          <path d="M4 6l8 0" />
          <path d="M8 6v-1a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v1" />
          <path d="M4 12s2-3 4-3 4 3 4 3" />
          <path d="M14.5 15l2.5-6 2.5 6" />
          <path d="M15.5 13h3" />
          <path d="M2 18l7-7" />
          <path d="M9 18l-2-2" />
        </svg>
      </button>

      {open && (
        <div className="lang-switcher-dropdown">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              className={`lang-switcher-option ${i18n.language === lang.code ? 'active' : ''}`}
              onClick={() => handleSelect(lang.code)}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
